import { render, staticRenderFns } from "./authGroup.vue?vue&type=template&id=48c88616"
import script from "./authGroup.vue?vue&type=script&lang=js"
export * from "./authGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48c88616')) {
      api.createRecord('48c88616', component.options)
    } else {
      api.reload('48c88616', component.options)
    }
    module.hot.accept("./authGroup.vue?vue&type=template&id=48c88616", function () {
      api.rerender('48c88616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/auth/authGroup.vue"
export default component.exports